<template>
    <div>
        <CardCarousel
            v-if="usersFavs.all?.length"
            title="Favorites"
            seeAllUrl="/hotels/favorites"
            :numCards="usersFavs.all?.length"
        >
            <template #carouselCard>
                <Slide v-for="property in usersFavs.all" :key="property.id">
                    <PropertyCardSmall
                        :property="property"
                        :widgetView="true"
                    />
                </Slide>
            </template>
        </CardCarousel>
        <!-- START EMPTY STATE - NO ALERTS FOUND -->
        <div v-else>
            <div class="flex justify-between pb-2">
                <div
                    class="grow shrink basis-0 flex-col justify-end items-start gap-1 flex"
                >
                    <h2
                        class="text-slate-800 text-opacity-95 text-lg font-medium leading-7"
                    >
                        Favorites
                    </h2>
                </div>
                <router-link
                    class="flex items-end text-slate-800 text-sm font-medium hover:text-slate-500 active:text-slate-500 focus:outline-none"
                    to="/hotels/favorites"
                    role="button"
                >
                    See all
                </router-link>
            </div>
            <div class="rounded-lg border border-slate-200 py-16">
                <EmptyState
                    title="No favorites yet"
                    description="Tap the heart on any hotel to save it to your favorites."
                    :hasAction="false"
                >
                    <template #image>
                        <div
                            class="w-16 h-16 bg-slate-200 rounded-full justify-center items-center flex text-slate-600"
                        >
                            <Icon icon="heart" />
                        </div>
                    </template>
                </EmptyState>
            </div>
        </div>
    </div>
</template>

<script>
import 'vue3-carousel/dist/carousel.css';
import { computed } from 'vue';
import { useHotelsStore } from '@/store/hotels';
import { Slide } from 'vue3-carousel';
import PropertyCardSmall from '@/components/hotels/favorites/property-card-small/property-card-small.vue';
import CardCarousel from '@/components/ui/card-carousel/card-carousel.vue';
import EmptyState from '@/components/ui/empty-state/empty-state.vue';
import Icon from '@/components/ui/icon/icon.vue';

export default {
    components: {
        CardCarousel,
        EmptyState,
        PropertyCardSmall,
        Slide,
        Icon,
    },
    props: {
        title: { type: String, required: false, default: 'Favorites' },
    },
    setup() {
        const hotelsStore = useHotelsStore();
        const usersFavs = computed(() => hotelsStore.usersFavHotels);

        hotelsStore.getUsersFavHotels();

        return {
            usersFavs,
        };
    },
};
</script>
